import moment from 'moment'
const _format = 'MM/DD/YYYY'
const _apiFormat = 'YYYY-MM-DDTHH:mm:ss'
const _formatMoment = (momentDate) => momentDate.format(_format)
const _validateDate = (diff, days) => {
  if (diff < days) {
    return false
  }
  return true
}

export default class DatePickerUtilities {

  static getDateFormat () {
    return _format
  }

  static getApiFormat () {
    return _apiFormat
  }

  static validate (date) {
    const diff = moment(date, _apiFormat).diff(moment(), 'days')
    if (diff < 0) {
      return false
    }
    return true
  }

  static validateDateDiff (date1, date2, days) {
    var date1IsFromApi = moment(date1, _apiFormat, true).isValid()
    var date2IsFromApi = moment(date2, _apiFormat, true).isValid()

    const diff = moment(date2, date2IsFromApi ? _apiFormat : _format).diff(
      moment(date1, date1IsFromApi ? _apiFormat : _format), 'days')
    return _validateDate(diff, days)
  }

  static addDaysToDate (days, date = '') {
    const momentDate = !date ? moment() : moment(date)
    return momentDate.add(days, 'day').format(_format)
  }

  static format (date = '') {
    const momentDate = !date ? moment() : moment(date)
    return _formatMoment(momentDate)
  }

  static formatFromApi (date = '') {
    const momentDate = !date ? moment() : moment(date, _apiFormat)
    return _formatMoment(momentDate)
  }
}
